export default __webpack_public_path__ + "static/media/redmi3.f5b3a740.jpg";